import { vodAsset } from '@/types/entities';
import { getVideoUrl } from '@/utils/videos';
import { STUDIO_WHITE_LABEL_FEATURE } from '@/constants/accountFeatures';
import { useBillingContext } from '@/features/billing/components/BillingContext';
import { useAccountFeatures } from '@/components/studio/hooks/useAccountFeatures';
import { StudioVideo } from '@/features/ai-video-creator/stores/studioVideoStore';

export const useGetVideoUrl = (video: StudioVideo) => {
  const { data } = useAccountFeatures();
  const { isProPlan } = useBillingContext();

  const whiteLabelFeature = data?.[STUDIO_WHITE_LABEL_FEATURE];
  const hideVideoWatermark = whiteLabelFeature?.enabled && whiteLabelFeature?.settings?.hideVideoWatermark;

  const shouldRemoveWatermark = isProPlan || hideVideoWatermark;

  return getVideoUrl({ video, shouldRemoveWatermark });
};
